import React, { Component } from 'react';
import SomethingWentWrong from 'components/SomethingWentWrong';
import PropTypes from 'prop-types';
import { logger } from 'utils/debug';

class ErrorBoundary extends Component {
  constructor() {
    super();
    this.state = {
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    logger('Uncaught error:', error, errorInfo);
  }

  render() {
    const { error } = this.state;
    const { children } = this.props;
    if (error) {
      return <SomethingWentWrong error={error} />;
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
